import { useContext } from "react";
import { filteredQuestionIds } from "../../../Common/CommonFunctions/filterQuestionIds";
import { ActionKind } from "../../../SupplierView/SupplierViewPropsTypes";
import Radio from "../Components/Radio";
import { RadioPropsTypes } from "../RadioPropsTypes";
import { CheckResponsiveContext } from "../../../Context/CheckResponsiveContext";
import RadioMobileView from "../Components/RadioMobileView";

function RadioContainer({
  oldOption,
  surveyAnswers,
  setSurveyAnswers,
  questionObjVariable,
  questionId,
  mainRefObject,
  checkNestedDependency,
  isPreview,
  dependencyAnsHash,
  setDependencyAnsHash,
  dispatch,
  reducerState,
  surveyAnswersInfo,
}: RadioPropsTypes) {
  const { isMobile } = useContext(CheckResponsiveContext);
  //yes-or-no
  const handleChangeInputYesOrNo: RadioPropsTypes["handleChangeInputYesOrNo"] =
    (questionId, type, score, optionId) => {
      oldOption!.current = surveyAnswers?.[questionId]?.optionId! ?? "";
      if (optionId === oldOption?.current) return; // this has to be done to prevent below steps when same opt clicked
      let surveyAnswersCopy = structuredClone(surveyAnswers);
      surveyAnswersCopy[questionId] = surveyAnswersCopy[questionId] || {};
      surveyAnswersCopy[questionId]["val"] = type;
      if (surveyAnswersInfo?.surveyInfo.isScoreEnable) {
        surveyAnswersCopy[questionId]["score"] = Number(score);
      }
      surveyAnswersCopy[questionId]["optionId"] = optionId;
      //dependency part
      //  if question has no children dont do the below steps
      if (questionObjVariable?.[questionId]?.dependentChildren.length) {
        let dependencyAnsHashCopy = new Set(dependencyAnsHash);
        if (oldOption!.current.length) {
          dependencyAnsHashCopy.delete(oldOption!.current);
          mainRefObject!.current.questionOptionsInfoRef.current
            .get(questionId)
            ?.selectedoptionsIds.delete(oldOption!.current);
          mainRefObject!.current.questionOptionsInfoRef.current.get(questionId)
            ?.selectedoptionsIds.size === 0 &&
            mainRefObject!.current.questionOptionsInfoRef.current.delete(
              questionId
            );
        }
        if (
          questionObjVariable?.[questionId]?.optionInfo?.optionObj?.[optionId]
            .dependentQuestionIds.length
        ) {
          dependencyAnsHashCopy.add(optionId);

          // store option ids of current question in map
          mainRefObject!.current.questionOptionsInfoRef.current.set(
            questionId,
            {
              selectedoptionsIds: new Set([optionId]),
            }
          );
        }

        if (oldOption!.current.length) {
          checkNestedDependency!(
            questionObjVariable?.[questionId]?.dependentChildren,
            surveyAnswersCopy,
            dependencyAnsHashCopy
          );
        }
        // filter out questions tht are dependent, and only keep questions to render
        const updatedFilterData = filteredQuestionIds(
          reducerState!.allQuestionIds,
          questionObjVariable,
          dependencyAnsHashCopy
        );
        dispatch!({
          type: ActionKind.QUESTION_IDS_TO_RENDER,
          payload: { updatedFilterData: updatedFilterData },
        });
        setDependencyAnsHash!(dependencyAnsHashCopy);
      }

      setSurveyAnswers!(surveyAnswersCopy);
    };

  return (
    <>
      {isMobile ? (
        <RadioMobileView
          handleChangeInputYesOrNo={handleChangeInputYesOrNo}
          questionId={questionId}
          questionObjVariable={questionObjVariable}
          surveyAnswers={surveyAnswers}
          isPreview={isPreview}
          surveyAnswersInfo={surveyAnswersInfo}
        />
      ) : (
        <Radio
          handleChangeInputYesOrNo={handleChangeInputYesOrNo}
          questionId={questionId}
          questionObjVariable={questionObjVariable}
          surveyAnswers={surveyAnswers}
          isPreview={isPreview}
          surveyAnswersInfo={surveyAnswersInfo}
        />
      )}
    </>
  );
}

export default RadioContainer;
